import React from 'react';
import { Check, X } from 'lucide-react';
import { getPasswordRuleResults } from '../../utils/passwordPolicy';

export default function PasswordStrengthIndicator({ password }) {
  const rules = getPasswordRuleResults(password);

  return (
    <ul className="space-y-1.5" aria-label="Password requirements">
      {rules.map((rule) => (
        <li key={rule.id} className="flex items-center gap-2 text-xs">
          {rule.passed ? (
            <Check className="h-3.5 w-3.5 shrink-0 text-emerald-500" aria-hidden="true" />
          ) : (
            <X className="h-3.5 w-3.5 shrink-0 text-gray-400" aria-hidden="true" />
          )}
          <span className={rule.passed ? 'text-emerald-700 dark:text-emerald-300' : 'text-gray-500 dark:text-gray-400'}>
            {rule.label}
          </span>
        </li>
      ))}
    </ul>
  );
}
